export const calculateEcpm = (revenueAmount, exposureCount) => {
  const revenue = Number(revenueAmount) || 0;
  const exposure = Number(exposureCount) || 0;
  return exposure > 0 ? (revenue / exposure) * 1000 : 0;
};

const metricColorMap = {
  requestCount:'var(--metric-request)',responseCount:'var(--metric-response)',
  exposureCount:'var(--metric-exposure)',validClickCount:'var(--metric-click)',
  clickCount:'var(--metric-click)',clickRate:'var(--metric-rate)',costAmount:'var(--metric-cost)',
  cpc:'var(--metric-cost)',revenueAmount:'var(--metric-revenue)',ecpm:'var(--metric-ecpm)',
};

export const metricColor = metric => metricColorMap[metric] || 'var(--color-primary)';

export const formatEcpm = value => Number(value || 0).toLocaleString("ko-KR", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
